<template>
  <el-dialog
    v-model="visible"
    :width="width"
    :fullscreen="fullscreen"
    :modal="modal"
    :center="center"
    :destroy-on-close="destroyOnClose"
    :show-close="false"
    :before-close="handleBeforeClose"
    :close-on-click-modal="closeOnClickModal"
    class="custom-dialog"
	:append-to-body="appendToBody"
    @open="handleOpen"
    @close="handleClose"
  >
    <div class="my-dialog" :style="{boxShadow:showShadow?'0 0 8px #ccc':'',}">
      <slot name="header">
        <div class="title">
          {{ title }}
          <el-icon @click="handleCancel" v-if="showClose">
            <CloseBold />
          </el-icon>
        </div>
      </slot>
      <div class="body">
        <!-- 插槽：对话框内容 -->
        <slot>

        </slot>
      </div>

      <!-- 插槽：底部按钮区域 -->
      <div class="footer" :class="footerAlign" v-if="showFooter">
        <slot name="footer">
          <!-- 默认按钮组 -->
          <el-button class="btn" @click="handleCancel">{{cancelText}}</el-button>
          <el-button class="btn" type="primary" @click="handleConfirm">{{confirmText}}</el-button>
        </slot>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { computed } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus'

// 定义属性
const props = defineProps({

  ///页脚的对齐
  footerAlign: {
    type: String,
    default: 'right',
  },

  // 控制对话框显示/隐藏（支持v-model）
  modelValue: {
    type: Boolean,
    default: false
  },
  // 对话框标题
  title: {
    type: String,
    default: '提示'
  },
  // 对话框宽度
  width: {
    type: String,
    default: '50%'
  },
  // 是否全屏
  fullscreen: {
    type: Boolean,
    default: false
  },
  // 是否显示遮罩层
  modal: {
    type: Boolean,
    default: true
  },
  // 内容是否居中
  center: {
    type: Boolean,
    default: false
  },
  // 关闭时是否销毁内容
  destroyOnClose: {
    type: Boolean,
    default: true
  },
  // 是否显示关闭按钮
  showClose: {
    type: Boolean,
    default: true
  },
  // 点击遮罩层是否关闭
  closeOnClickModal: {
    type: Boolean,
    default: true
  },
  // 是否有未保存的修改（用于关闭前确认）
  hasUnsavedChanges: {
    type: Boolean,
    default: false
  },
  // 未保存修改时的提示文本
  unsavedChangesMessage: {
    type: String,
    default: '您有未保存的修改，确定要放弃吗？'
  },
  showFooter:{
	  type:Boolean,
	  default:true
  },
  showShadow:{
	  type:Boolean,
	  default:false
  },
  appendToBody:{
	  type:Boolean,
	  default:false
  },
  cancelText:{
    type: String,
    default: '取消'
  },
  confirmText:{
    type: String,
    default: '确定'
  },
});

// 定义事件
const emit = defineEmits([
  'update:modelValue', // 用于v-model双向绑定
  'confirm', // 确认按钮点击
  'cancel', // 取消按钮点击
  'open', // 对话框打开时
  'close' // 对话框关闭时
]);

// 计算属性：控制对话框显示状态（v-model双向绑定）
const visible = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  }
});

// 处理关闭前的确认逻辑
const handleBeforeClose = async (done) => {
  // debugger
  if (props.hasUnsavedChanges) {
    // 有未保存的修改，显示确认提示
    try{
      var res = await ElMessageBox.confirm(
        props.unsavedChangesMessage,
        'Warning',
        {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        }
      );
      console.log("confirm res:", res);
      if(res) done();
    }catch(e){console.warn("click cancel", e)}
  } else {
    // 无未保存修改，直接关闭
    done();
    emit('close');
  }
};

// 处理确认按钮点击
const handleConfirm = () => {
  emit('confirm');
};

// 处理取消按钮点击
const handleCancel = () => {
  visible.value = false;
  emit('cancel');
};

// 处理对话框打开事件
const handleOpen = () => {
  emit('open');
};

// 处理对话框关闭事件
const handleClose = () => {
  emit('close');
};
</script>

<style scoped lang="scss">
.custom-dialog {
  /* 自定义基础样式 */
  --el-dialog-border-radius: 8px;
}

/* 对话框标题样式 */
:deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 600;
  color: #1f2329;
}

/* 对话框内容区域样式 */
:deep(.el-dialog__body) {
  padding: 20px;
  font-size: 14px;
  line-height: 1.6;
}

/* 底部按钮区域样式 */
:deep(.el-dialog__footer) {
  padding: 16px 20px;
  border-top: 1px solid #f2f3f5;
}




.my-dialog {
  width: 100%;
  height: auto;
  border-radius: 10px;
  background: #FFF;
  overflow: hidden;
  font-family: PingFang-SC-Bold;

  .title {
    width: 100%;
    height: 48px;
    line-height: 48px;
    text-align: left;
    text-indent: 23px;
    font-weight: bold;
    font-size: 14px;
    background-color: #F8FEF8;
    color: #2B2C3C;
    border-bottom: 1px solid #EFEFEF;
    position: relative;

    .el-icon {
      position: absolute;
      top: 50%;
      right: 26px;
      transform: translateY(-50%);
      cursor: pointer;
    }
  }

  .body {
    width: 100%;
    height: auto;
    overflow-y: auto;
    padding: 0 18px;

    .groupBox {
      width: 100%;
      display: flex;
      padding-top: 18px;
      border-bottom: 1px solid #EFEFEF;

      .groupName {
        width: 52px;
        text-align: center;
        font-size: 16px;
        color: #2B2C3C;
      }

      .list {
        flex: 1;
        display: flex;
        flex-wrap: wrap;

        .item {
          width: calc(100% / 3);
          margin-bottom: 22px;

          .checkBox {
            font-size: 16px;
          }

          .label {
            flex: 1;
          }

          .count {
            font-size: 16px;
            color: #A2A6BA;
            margin-left: 10px;
          }
        }
      }
    }
  }

  .footer {
    width: 100%;
    min-height: 49px;
    border-top: 1px solid #E5E5E5;
    // background: rgba(245, 247, 249, 1);
    // border-radius: 10px 0px 10px 10px;
    justify-content: space-between;
    align-items: center;
    display: flex;
    padding: 0 23px;
    
  }
  .footer.middle{
    justify-content: center
  }
  .footer.left{
    justify-content: flex-start;
  }
  .footer.right{
    justify-content: flex-end;
  }
}

</style>

<style lang="scss">
// 往外打的样式
.my-dialog{
  .footer{
    .btn {
      width: auto;
      height: 34px;
      padding: 0px 19px;
      background: linear-gradient(286deg, #52A401 0%, #D2D54C 100%);
      border-radius: 4px;
      // border: 1px solid #E8E8E8;
      // font-family: PingFang-SC-Bold;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;

      &+.btn {
        margin-left: 13px !important;
      }
    }
    .btn + .btn{
      margin-left: 13px !important;
    }

    .left {
      flex:1;
    }

    .middle{
      flex:auto;
    }

    .right {
      flex:1;
      .text {
        font-family: PingFang-SC-Bold;
        // font-weight: bold;
        font-size: 14px;
        color: #2B2C3C;

        .num {
          color: var(--qx2-primary-color);
        }
      }

      .submit {
        margin-left: 16px;
        color: #fff;
        background: var(--qx2-primary-linearGradient-color);
      }
    }
  }
}
</style>